export default class AutoSubmitForm extends HTMLElement {
  connectedCallback() {
    const form = this.querySelector('form')
    if (!form) return
    this._onChange = () => form.requestSubmit()
    this.addEventListener('change', this._onChange)
    this.classList.add('enhanced')
  }

  disconnectedCallback() {
    if (this._onChange) {
      this.removeEventListener('change', this._onChange)
      this._onChange = null
    }
    this.classList.remove('enhanced')
  }
}
